if (!window.GiftBagCheckboxDefined) {
  class GiftBagCheckbox extends HTMLElement {
    constructor() {
      super();
      this.variantId = '51692003787025';
      this.isChecked = false;
      this.init();
      this.cartUpdateTimeout = null;
    }

    async init() {
      this.checkbox = this.querySelector('input[type="checkbox"]');
      if (this.checkbox) {
        this.checkbox.addEventListener('change', this.handleCheckboxChange.bind(this));
      } else {
        console.error('Gift bag checkbox not found');
        return;
      }
      await this.checkIfGiftBagInCart();
      document.addEventListener('cart:updated', this.handleCartUpdate.bind(this));
    }

    async checkIfGiftBagInCart() {
      if (!this.checkbox) return;
      try {
        const response = await fetch('/cart.js');
        const cart = await response.json();
        const giftBagItem = cart.items.find(item => item.variant_id.toString() === this.variantId);
        this.isChecked = !!giftBagItem;
        this.checkbox.checked = this.isChecked;
        if (cart.item_count === 0) {
          this.checkbox.disabled = true;
          this.classList.add('disabled');
        } else {
          this.checkbox.disabled = false;
          this.classList.remove('disabled');
        }
      } catch (error) {
        console.error('Error checking cart for gift bag:', error);
      }
    }

    async handleCheckboxChange(event) {
      this.classList.add('loading');
      await this.syncGiftBagWithCheckbox();
      this.classList.remove('loading');
      await this.checkIfGiftBagInCart();
      this.refreshCartSections();
    }

    async syncGiftBagWithCheckbox() {
      // Always check cart state before acting
      const response = await fetch('/cart.js');
      const cart = await response.json();
      const giftBagItem = cart.items.find(item => item.variant_id.toString() === this.variantId);
      const isChecked = this.checkbox.checked;
      if (isChecked && !giftBagItem) {
        // Only add if not present
        await this.addGiftBagToCart();
      } else if (!isChecked && giftBagItem) {
        // Only remove if present
        await this.removeGiftBagFromCart();
      }
      // If already in desired state, do nothing
    }

    async addGiftBagToCart() {
      try {
        const formData = new FormData();
        formData.append('id', this.variantId);
        formData.append('quantity', '1');
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          body: formData
        });
        if (response.ok) {
          this.isChecked = true;
          this.updateCart();
        } else {
          console.error('Failed to add gift bag to cart');
          this.checkbox.checked = false;
        }
      } catch (error) {
        console.error('Error adding gift bag to cart:', error);
        this.checkbox.checked = false;
      }
    }

    async removeGiftBagFromCart() {
      try {
        const formData = new FormData();
        formData.append('id', this.variantId);
        formData.append('quantity', '0');
        const updateResponse = await fetch('/cart/change.js', {
          method: 'POST',
          body: formData
        });
        if (updateResponse.ok) {
          this.isChecked = false;
          this.updateCart();
        } else {
          console.error('Failed to remove gift bag from cart');
          this.checkbox.checked = true;
        }
      } catch (error) {
        console.error('Error removing gift bag from cart:', error);
        this.checkbox.checked = true;
      }
    }

    handleCartUpdate(event) {
      if (this.cartUpdateTimeout) clearTimeout(this.cartUpdateTimeout);
      this.cartUpdateTimeout = setTimeout(() => {
        if (event.detail && event.detail.source === 'gift-bag-checkbox') return;
        this.checkIfGiftBagInCart();
      }, 200);
    }

    updateCart() {
      const cartUpdateEvent = new CustomEvent('cart:updated', {
        detail: { source: 'gift-bag-checkbox' }
      });
      document.dispatchEvent(cartUpdateEvent);
      this.refreshCartSections();
    }

    async refreshCartSections() {
      const sections = [
        {id: 'CartDrawer-CartItems', section: 'cart-drawer', selector: '#CartDrawer-CartItems'},
        {id: 'main-cart-items', section: 'main-cart-items', selector: '#main-cart-items'},
        {id: 'main-cart-footer', section: 'main-cart-footer', selector: '#main-cart-footer'},
        {id: 'CartDrawer', section: 'cart-drawer', selector: '#CartDrawer'}
      ];
      for (const s of sections) {
        try {
          const url = `/cart?section_id=${s.section}`;
          const response = await fetch(url);
          if (response.ok) {
            const html = await response.text();
            const temp = document.createElement('div');
            temp.innerHTML = html;
            const newContent = temp.querySelector(s.selector);
            const target = document.getElementById(s.id) || document.querySelector(s.selector);
            if (newContent && target) {
              target.innerHTML = newContent.innerHTML;
            }
          }
        } catch (e) {
          // fail silently
        }
      }
    }

    disconnectedCallback() {
      document.removeEventListener('cart:updated', this.handleCartUpdate.bind(this));
    }
  }

  if (!customElements.get('gift-bag-checkbox')) {
    customElements.define('gift-bag-checkbox', GiftBagCheckbox);
  }
  window.GiftBagCheckboxDefined = true;
} 